import React, { useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid2,
} from '@mui/material';
import AuthContext from '../Context/AuthProvider';
import { NoteTypes } from '../Utility/Constants';

function NoteTypeDialog({ open, onClose, onSelect }) {
  const { auth } = useContext(AuthContext);
  const [noteType, setNoteType] = React.useState('');

  // Get allowed prescriptions from auth context
  const allowedPrescriptions = 
    auth?.selectedFacility?.licenseDetails?.allowedPrescriptions || [];

  // Filter note types based on what's allowed
  const availableNoteTypes = NoteTypes.filter(note => 
    allowedPrescriptions.includes(note.value)
  );

  // Debug: Log to see what's happening
  console.log('Allowed Prescriptions:', allowedPrescriptions);
  console.log('All Note Types:', NoteTypes);
  console.log('Available Note Types:', availableNoteTypes);

  const handleChange = (event) => {
    setNoteType(event.target.value);
  };

  const handleSubmit = () => {
    if (noteType) {
      // Map the value to the expected format for handleNoteTypeSelect
      const mappedNoteType = noteType === "General" ? "General" : "Physiotherapy";
      onSelect(mappedNoteType);
      onClose();
      // Reset selection
      setNoteType('');
    }
  };

  const handleClose = () => {
    setNoteType('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Select Note Type</DialogTitle>
      <DialogContent dividers>
        <Grid2 container justifyContent="center" sx={{ py: 2 }}>
          <Grid2 item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="note-type-label">Note Type</InputLabel>
              <Select
                labelId="note-type-label"
                value={noteType}
                label="Note Type"
                onChange={handleChange}
                sx={{ minWidth: 250 }}
              >
                {availableNoteTypes.map((note) => (
                  <MenuItem key={note.value} value={note.value}>
                    {note.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          disabled={!noteType} 
          variant="contained"
          color="secondary"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NoteTypeDialog;